


































































































































































































































import { Component, Vue } from "vue-property-decorator";
import questionAdd from "./components/questionAdd.vue";
import questionEdit from "./components/questionEdit.vue";
import questionPreview from "./components/questionPreview.vue";
import { getQuestionTypeAllList, QuestionTypeForm } from "@/serve/question/questionType";
import {
  addQuestion,
  copyQuestion,
  deleteQuestion,
  disableQuestion,
  enableQuestion,
  getQuestionList,
  previewQuestion,
  QuestionCopyForm,
  QuestionForm,
  QuestionPreview,
  updateQuestion
} from "@/serve/question/question";

interface QuestionQuery {
  current: number;
  size: number;
  questionCode: string;
  questionName: string;
  typeId: number | null;
  status: number | null;
}

@Component({
  name: "questionConfig",
  components: {
    questionAdd,
    questionEdit,
    questionPreview
  }
})
export default class QuestionConfig extends Vue {
  public form: QuestionQuery = {
    current: 1,
    size: 10,
    questionCode: "",
    questionName: "",
    typeId: null,
    status: null
  };

  public typeList: QuestionTypeForm[] = [];
  public tableData: QuestionForm[] = [];
  public total = 0;
  public loading = false;
  public submitLoading = false;
  public questionDialog = false;
  public isAddQuestion = true;
  public questionForm: QuestionForm = this.emptyQuestionForm();
  public copyDialog = false;
  public copyForm: QuestionCopyForm = { id: 0, questionCode: "", questionName: "" };

  public previewDialog = false;
  public previewData: QuestionPreview = {
    question: this.emptyQuestionForm(),
    items: []
  };

  public get questionDialogTitle() {
    return this.isAddQuestion ? "新增问卷" : "修改问卷";
  }

  public get isEditPage() {
    return !!this.$route.query.id;
  }

  public created() {
    this.restoreFormFromRoute();
    this.getTypeList();
    if (!this.isEditPage) {
      this.getTableData();
    }
  }

  private emptyQuestionForm(): QuestionForm {
    return {
      id: null,
      questionCode: "",
      questionName: "",
      typeId: null,
      description: "",
      status: 0,
      sort: 0,
      scoreEnabled: 0,
      scoreMethod: "none"
    };
  }

  public async getTypeList() {
    const res = await getQuestionTypeAllList();
    if (res.success) {
      this.typeList = res.data || [];
    }
  }

  public search() {
    this.form.current = 1;
    this.getTableData();
  }

  public async getTableData() {
    this.loading = true;
    try {
      const dataItem = { ...this.form };
      const res = await getQuestionList((this as any).$changNull(dataItem));
      if (res.success) {
        this.tableData = res.data.records || [];
        this.total = res.data.total || 0;
      }
    } finally {
      this.loading = false;
    }
  }

  public resetForm() {
    this.form = {
      current: 1,
      size: 10,
      questionCode: "",
      questionName: "",
      typeId: null,
      status: null
    };
    this.getTableData();
  }

  public addNewQuestion() {
    this.isAddQuestion = true;
    this.questionForm = {
      ...this.emptyQuestionForm(),
      sort: this.total + 1
    };
    this.questionDialog = true;
  }

  public editQuestion(row: QuestionForm) {
    this.isAddQuestion = false;
    this.questionForm = {
      ...row,
      scoreMethod: row.scoreMethod || "none"
    };
    this.questionDialog = true;
  }

  public async submitQuestion() {
    this.submitLoading = true;
    try {
      const submitData = { ...this.questionForm };
      if (submitData.scoreEnabled !== 1) {
        submitData.scoreMethod = "none";
      }
      const res = this.isAddQuestion
        ? await addQuestion(submitData)
        : await updateQuestion(submitData);
      if (res.success) {
        this.$message.success(res.msg || "保存成功");
        this.questionDialog = false;
        this.getTableData();
      } else {
        this.showApiMessage(res, "保存失败", "warning");
      }
    } finally {
      this.submitLoading = false;
    }
  }

  public openQuestionEditor(row: QuestionForm) {
    this.$router.push({
      path: "/questionManageEdit",
      query: {
        id: String(row.id),
        ...this.getListRouteQuery()
      }
    });
  }

  public deleteQuestionRow(row: QuestionForm) {
    (this as any).$messageBox
      .confirm(`您确定要删除问卷【${row.questionName}】吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(async () => {
        const res = await deleteQuestion(row.id as number);
        if (res.success) {
          this.$message.success("删除成功");
          this.getTableData();
        } else {
          this.showApiMessage(res, "删除失败");
        }
      });
  }

  public async switchChange(row: QuestionForm) {
    const isEnable = row.status === 1;
    const text = isEnable ? "启用" : "停用";
    const res = isEnable
      ? await enableQuestion(row.id as number)
      : await disableQuestion(row.id as number);
    if (res.success) {
      this.$message.success(`${text}成功`);
      this.getTableData();
    } else {
      this.showApiMessage(res, `${text}失败`);
      this.getTableData();
    }
  }

  public async toggleStatus(row: QuestionForm) {
    row.status = row.status === 1 ? 0 : 1;
    await this.switchChange(row);
  }

  public openCopyQuestion(row: QuestionForm) {
    this.copyForm = {
      id: row.id as number,
      questionCode: "",
      questionName: `${row.questionName}-副本`
    };
    this.copyDialog = true;
  }

  public async submitCopyQuestion() {
    this.submitLoading = true;
    try {
      const res = await copyQuestion({
        ...this.copyForm,
        questionCode: this.copyForm.questionCode || undefined,
        questionName: this.copyForm.questionName || undefined
      });
      if (res.success) {
        this.$message.success("复制成功");
        this.copyDialog = false;
        const copied = res.data;
        if (copied && copied.id) {
          this.$router.push({
            path: "/questionManageEdit",
            query: {
              id: String(copied.id),
              ...this.getListRouteQuery()
            }
          });
        } else {
          this.getTableData();
        }
      } else {
        this.showApiMessage(res, "复制失败");
      }
    } finally {
      this.submitLoading = false;
    }
  }

  public async openPreview(id: number) {
    const res = await previewQuestion(id);
    if (res.success) {
      this.previewData = res.data || { question: this.emptyQuestionForm(), items: [] };
      this.previewDialog = true;
    }
  }

  public handleSizeChange(size: number) {
    this.form.size = size;
    this.form.current = 1;
    this.getTableData();
  }

  public handleCurrentChange(current: number) {
    this.form.current = current;
    this.getTableData();
  }

  private restoreFormFromRoute() {
    const query = this.$route.query;
    this.form = {
      current: this.numberQueryValue(query.current, 1) as number,
      size: this.numberQueryValue(query.size, 10) as number,
      questionCode: this.stringQueryValue(query.questionCode),
      questionName: this.stringQueryValue(query.questionName),
      typeId: this.numberQueryValue(query.typeId, null),
      status: this.numberQueryValue(query.status, null)
    };
  }

  private getListRouteQuery() {
    const query: { [key: string]: string } = {
      current: String(this.form.current),
      size: String(this.form.size)
    };
    if (this.form.questionCode) {
      query.questionCode = this.form.questionCode;
    }
    if (this.form.questionName) {
      query.questionName = this.form.questionName;
    }
    if (this.form.typeId !== null && this.form.typeId !== undefined) {
      query.typeId = String(this.form.typeId);
    }
    if (this.form.status !== null && this.form.status !== undefined) {
      query.status = String(this.form.status);
    }
    return query;
  }

  private stringQueryValue(value: string | (string | null)[] | null | undefined) {
    if (Array.isArray(value)) {
      return value[0] || "";
    }
    return value || "";
  }

  private numberQueryValue(
    value: string | (string | null)[] | null | undefined,
    defaultValue: number | null
  ) {
    const rawValue = Array.isArray(value) ? value[0] : value;
    if (rawValue === null || rawValue === undefined || rawValue === "") {
      return defaultValue;
    }
    const numberValue = Number(rawValue);
    return Number.isNaN(numberValue) ? defaultValue : numberValue;
  }

  private showApiMessage(res: any, fallback: string, type: "error" | "warning" = "error") {
    if (res && res.__messageShown) {
      return;
    }
    this.$message[type]((res && res.msg) || fallback);
  }
}
